export default __webpack_public_path__ + "static/media/file-protect.2870923d.svg";